
import classNames from 'classnames';
import st from './RdcCard.module.scss';
import { SearchInput } from 'src/Components';
import { Headline } from 'src/UI';

interface IRdcCardHeaderProps extends React.AreaHTMLAttributes<HTMLDivElement> {
	title: string;
	titleCentered?: boolean;
	searchEnable?: boolean;
	defaultSearch?: string;
	searchPlaceholder?: string;
	debounceDelay?: number; 
	disabled?: boolean;
	onSearch?: ( text: string ) => void;
};

const RdcCardHeader: React.FC<IRdcCardHeaderProps> = ( props ) => {
	const  { title, titleCentered = false, 
		searchEnable = false, searchPlaceholder, defaultSearch, onSearch, 
		children, className, ...otherProps 
	} = props;

	return (
		<div className={classNames(st.rdc_card__header, className)} {...otherProps}>
			{
				!!title &&
				<Headline className={classNames(st.rdc_card__header__title, { [st.rdc_card__header__title_centered]: titleCentered } )}>
					{title}
				</Headline>
			}
			{children}
			{ searchEnable && <SearchInput placeholder={searchPlaceholder} defaultSearch={defaultSearch} onSearch={onSearch} /> }
		</div>
	);
};

export default RdcCardHeader;
